module.exports = __webpack_public_path__ + "img/concrete-hole-decal-11.d960cdbe.png";